var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoweredByPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "72px",
    viewBox: "0 0 64 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "electric-thought") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-1073.000000, -685.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3.13621769
  }, /*#__PURE__*/React.createElement("g", {
    id: "Why",
    transform: "translate(0.000000, 620.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(965.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "electric-thought",
    transform: "translate(110.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5245415,69 L50.5245415,69 C50.7196072,58.263845 53.1663323,47.6881589 57.70648,37.9569018 C59.1250629,34.741064 59.9027259,31.2794742 59.9959189,27.7659858 C60.2490053,12.9892424 48.6999616,0.69188094 33.9339499,0.0153373877 C26.6161033,-0.23123837 19.5118258,2.50396495 14.2493623,7.59406013 C8.98689882,12.6841553 6.01745801,19.6927127 6.02161249,27.0134258 C6.02161249,27.6405591 6.02161249,28.2363357 6.02161249,28.8321124 L0.470507181,41.029855 C0.156989076,41.6744871 -0.00397420446,42.3826011 0,43.0993949 L0,43.0993949 C0.0173176674,45.8060372 2.21676329,47.9910895 4.9239363,47.9910346 L6.02161249,47.9910346 L6.02161249,51.1267011 C6.01324199,53.5160363 6.9588649,55.8099252 8.64868739,57.4994507 C10.3385099,59.1889762 12.632802,60.1344329 15.0225573,60.1260639 L21.0127331,60.1260639 L21.0127331,69",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "36.0038536 21.0243028 30.0136778 29.992309 36.0038536 29.992309"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "36.0038536 39.0230284 42.0253916 29.992309 36.0038536 29.992309"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredByPeople);
export default __webpack_public_path__ + "static/media/powered-by-people.fbf45b14e29c8187b9c306255f224961.svg";
export { ForwardRef as ReactComponent };